import { render } from "./SendTestModal.vue?vue&type=template&id=5647a101&scoped=true"
import script from "./SendTestModal.vue?vue&type=script&lang=ts"
export * from "./SendTestModal.vue?vue&type=script&lang=ts"

import "./SendTestModal.vue?vue&type=style&index=0&id=5647a101&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5647a101"

export default script